import type { Variants } from 'motion/react';

/** Shared cubic-bezier ease used across the app (matches `--ease-out-soft`). */
export const EASE = [0.22, 1, 0.36, 1] as const;

/** Spring used for layout-id pill transitions in the sidebar / pickers. */
export const SPRING_PILL = { type: 'spring', stiffness: 420, damping: 34 } as const;
export const SPRING_INDICATOR = { type: 'spring', stiffness: 460, damping: 32 } as const;
export const SPRING_SHEET = { type: 'spring', stiffness: 320, damping: 34 } as const;

/** Interactive press / hover spring — the one motion vocab for tap & lift feedback. */
export const SPRING_PRESS = { type: 'spring', stiffness: 400, damping: 30 } as const;

/** Grid container — reveals its motion children (parent just propagates `show`). */
export const cardStagger: Variants = { hidden: {}, show: {} };

/** Grid card — subtle fade + 6px rise. `custom` = index; the per-card delay is
 *  CAPPED so large grids still feel instant (never more than ~12 cards of stagger). */
export const cardItem: Variants = {
  hidden: { opacity: 0, y: 6 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.22, ease: EASE, delay: Math.min(i, 12) * 0.04 },
  }),
};

/** Container variant — fades in and staggers children. */
export const stagger: Variants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.04 },
  },
};

/** Item variant — slides up gently into place. */
export const item: Variants = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE } },
};

/** Slide-up sheet (mobile preview sheets). */
export const slideUpSheet: Variants = {
  hidden: { y: '100%' },
  show: { y: 0, transition: SPRING_SHEET },
  exit: { y: '100%', transition: SPRING_SHEET },
};

/** Soft fade. */
export const fade: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.25 } },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};
